export const FILE_LIMIT_SIZE_MB: number = 10;
export const FILE_LIMIT_SIZE_BYTES: number = FILE_LIMIT_SIZE_MB * 1024 * 1024;
